module.exports = __webpack_public_path__ + "static/img/multi-secure-computing.65dd7f8e.png";